<template>
  <div style="margin:20px">
    <div>
      <a-row :gutter="24" style="padding:0px;">
        <a-col :md="{span:24}" :lg="{span:16}">
          <!-- <z-device-distribute-map></z-device-distribute-map> -->
          <ZDeviceDistributeMap />
        </a-col>
        <a-col :md="{span:24}" :lg="{span:8}">
          <SideDeviceCount />
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
  import ZDeviceDistributeMap from '@/views/overview/DeviceDistributeMap.vue'
  import SideDeviceCount from '@/views/overview/SideDeviceCount'
  // import {mapActions} from 'vuex'
  export default {
    data() {
      return {

      }
    },
    components: {
      // ZDeviceDistributeMap: () => import('@/views/overview/DeviceDistributeMap.vue')
      ZDeviceDistributeMap,
      SideDeviceCount
    },
    // methods: {
      
    // }
  }
</script>